import { useState } from "react";
import { Popover } from "antd";
import type { ValueChangedPropsOptional } from "@type/util";
import { ImageTagPopoverContent } from "./ImageTagPopoverContent";
import { PlusCaption } from "./PlusCaption";
import { TestId } from "@shared/testIds";

export interface ImageTagSelectorProps extends ValueChangedPropsOptional<string> {
  disabled?: boolean;
}

export const ImageTagSelector = ({ value = "", onChange, disabled }: ImageTagSelectorProps) => {
  const [open, setOpen] = useState(false);
  const handleSave = (newValue: string) => {
    onChange?.(newValue);
    setOpen(false);
  };

  return (
    <Popover
      open={open}
      onOpenChange={(next) => {
        if (!disabled) setOpen(next);
      }}
      trigger="click"
      getPopupContainer={() => document.body}
      content={<ImageTagPopoverContent currentValue={value} onSave={handleSave} />}
      arrow={false}
      placement="bottomLeft"
      align={{ offset: [-8, 0] }}
    >
      <div
        data-testid={TestId.VideoImageCaptionTrigger}
        onClick={(e) => {
          if (disabled) return;
          e.stopPropagation();
          setOpen(!open);
        }}
      >
        <PlusCaption value={value} />
      </div>
    </Popover>
  );
};
